<template>
  <div>
    <div class="row">
      <div class="col">
        <v-text-field
          :label="phrase.label"
          placeholder="Type phrase here"
          v-model="phraseText"
          outline
          :counter="phrase.manifest.maxCharacters"
          :rules="[rules.max]"
          v-validate="{isCharactersValid: phrase}"
          data-vv-name="phraseText"
          data-vv-scope="bandbuildersiliconetext"
          data-vv-delay="500"
          :error-messages="errors.collect('phraseText', 'bandbuildersiliconetext')"
        ></v-text-field>
      </div>
      <div class="col-md-3 col-lg-auto">

        <v-select
          :items="fonts"
          label="Font"
          outline
          menu-props="auto"
          item-text="name"
          item-value="name"
          :value="phrase.font"
          @input="setFont"
          v-validate="{isCharactersValid: phrase}"
          data-vv-name="phraseText"
          data-vv-scope="bandbuildersiliconetext"
          :error-messages="errors.collect('phraseText', 'bandbuildersiliconetext')"
        >
          <template slot="selection" slot-scope="data">
            <a :style="{ fontFamily: data.item.name }">{{ data.item.name }}</a>
          </template>
          <template slot="item" slot-scope="data">
            <a :style="{ fontFamily: data.item.name }">{{ data.item.name }}</a>
          </template>
        </v-select>

      </div>
      <div class="col-md-3 col-lg-2" v-if="phrase.manifest.colorFill && !customband.hasMultipleItems()">
        <div class="d-block d-md-none">
          <pricing :tiers="customband.getPrintColorPricingTiers()" :type="'color_fill'" :btn-text="'Text Color Pricing'" v-if="customband.getPrintColorPricingTiers()"></pricing>
        </div>
        <colors-select :colors="printColors" :color-value="phrase.colorFill" :color-required="customband.isPrinted()" label="Text Color" :show-label="false" :is-print-color="true" :row-position="0"></colors-select>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import _debounce from 'lodash/debounce'
  import axios from 'axios'
  import GetCookie from '../../utils/getcookie'

  let stateName = 'bandbuilder.silicone.text'
  let getCookie = new GetCookie()

  const config = {
    headers: {
      'X-CSRFToken': getCookie.csrf()
    }
  }

  const emojiRegex = require('emoji-regex')
  const regex = emojiRegex();

  export default {
    $_veeValidate: {
      validator: 'new'
    },

    props: ['phrase'],
    data () {
      return {
        setTextTimeout: null,
        rules: {
          max: v => v.length <= this.phrase.manifest.maxCharacters || `Max ${this.phrase.manifest.maxCharacters} characters`,
          isEmoji: v => !regex.exec(v) || 'Emojis are not allowed'
        }
      }
    },
    computed: {
      phraseText: {
        get () {
          return this.phrase.text
        },
        set: _debounce(function (text) {
          let payload = {
            obj: this.phrase,
            text: text
          }
          this.$store.commit('customband/setText', payload)
          this.$store.dispatch('customstates/stepIsDirty', stateName)
          this.$root.$data.fixedPreview.renderAreas()
          this.$store.dispatch('customband/checkCompletion')
        }, 500)
      },
      fonts () {
        return this.customband.getFonts()
      },
      printColors () {
        return this.customband.getPrintColors()
      },
      ...mapState([
        // map this.customband to store.state.customband
        'customband',
        'alerts'
      ])
    },
    methods: {
      setFont (fontName) {
        let payload = {
          obj: this.phrase,
          fontName
        }
        this.$store.commit('customband/setFont', payload)
        this.$store.dispatch('customstates/stepIsDirty', stateName)
        this.$root.$data.fixedPreview.renderAreas()
        this.$store.dispatch('customband/checkCompletion')
      }
    },

    created () {
      const charactersValid = (value, phraseObj) => {
        let isValid = true
        let msg = ''
        let invalidChars = this.customband.validateFontCharacters(phraseObj.text, phraseObj.font)
        if (invalidChars.length) {
          isValid = false
          let charPlural = invalidChars.length > 1 ? 's' : ''
          let doPlural = invalidChars.length > 1 ? `don't` : `doesn't`

          msg = `The character${charPlural} ("${invalidChars.join('", "')}") ${doPlural} exist in the font ${phraseObj.font}`
        }

        return {
          valid: isValid,
          data: {
            message: msg
          }
        }
      }

      this.$validator.extend('isCharactersValid', {
        validate: charactersValid,
        getMessage: (field, params, data) => {
          return data.message
        }
      })
    },

    mounted () {
      // console.log('this.fonts', this.fonts)

      // This makes sure the fields are validated after coming back from another step
      this.$validator.validateAll('bandbuildersiliconetext')
    }
  }
</script>
